<template>
  <div>
    <material-card icon="mdi-clipboard-text" inline :title="`Module listing of ${role}`">
      <v-card-actions>
        <router-link :to="{ name: 'ListDynamicModule' }">
          <v-btn color="success" elevation="1" absolute right top> <v-icon left>mdi-text-box-check</v-icon> List</v-btn>
        </router-link>
      </v-card-actions>
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-card-title>
          <!-- Total Records : {{ total }} -->
          <v-spacer></v-spacer>
        </v-card-title>
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="40"
        :headers="headers"
        :items="data"
        :search.sync="search"
      >
        <template v-slot:item.checkboxisActive="{ item }">
          <v-checkbox class="pa-0 pt-2 ma-0 mt-2" v-model="item.isActive"></v-checkbox>
        </template>
        <template v-slot:item.checkboxisDefault="{ item }">
          <v-checkbox class="pa-0 pt-2 ma-0 mt-2" v-model="item.isDefault"></v-checkbox>
        </template>
        <template v-slot:item.checkboxisWrite="{ item }">
          <v-checkbox class="pa-0 pt-2 ma-0 mt-2" v-model="item.isWrite"></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }"> </template>
        <template v-slot:item.module="{ item }">
          <div v-if="item.subDashboards && item.subDashboards.length > 0">
            <multiselect
              required
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="false"
              :preselect-first="false"
              :multiple="true"
              v-model="item.selectedModule"
              :options="item.subDashboards.map(type => type.id)"
              :custom-label="opt => item.subDashboards.find(x => x.id == opt).name"
              ><template slot="tags" slot-scope="{ values }"
                ><span class="multiselect__single" v-if="values.length">
                  {{ values.name }}
                </span></template
              >
            </multiselect>
          </div>
        </template>
        <template v-slot:item.isWrite="{ item }">
          <v-checkbox class="pa-0 pt-2 ma-0 mt-2" v-model="item.isWrite"></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn @click="saveRow(item)" class="px-2 ml-1 ma-1" color="primary" min-width="0" small>
            <v-icon small>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </material-card>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
// @ is an alias to /src
import MaterialCard from '@/components/template/MaterialCard'
// import stores from '@/stores'
import constants from '@/utils/constants'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'

export default {
  name: 'DynamicLevelListing',
  components: {
    MaterialCard,
    Multiselect
  },
  props: ['roleId'],
  data () {
    return {
      selectedValues: [],
      search: '',
      data: [],
      role: '',
      current: 1,
      rangeBefore: 3,
      rangeAfter: 1,
      order: 'is-right',
      headers: [
        { text: 'isActive', value: 'checkboxisActive', sortable: true },
        { text: 'Active/Deactive', value: 'isActiveInactive', align: 'center', sortable: true },
        { text: 'Path Name', value: 'name', sortable: true },
        { text: 'isDefault', value: 'checkboxisDefault', sortable: true },
        { text: 'isWrite', value: 'checkboxisWrite', sortable: true },
        { text: 'Module', value: 'module', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      size: '',
      total: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isModalActive: false,
      trashObject: null,
      isLoading: false,
      paginated: false,
      perPage: 10,
      checkedRows: [],
      content: '',

      models: [],
      loadingComponent: null
    }
  },
  created () {
    this.getUser()
  },
  computed: {},
  methods: {
    // addUser: async function () {
    //   this.$router.push({ name: 'SaveUser' })
    // },
    getUser: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/dashboard-role-map/roleID?roleID=${this.roleId}`)
        // const roleResponse = await http.get(`${constants.API_URL}/api/dashboard-by-role/${this.roleId}`)
        this.role = response.data.role.role
        this.data = []
        response.data.dashboardsByRole.forEach(obj => {
          obj.isDefault = obj.dashboardRoleMap ? obj.dashboardRoleMap.isDefault : false
          obj.isWrite = obj.dashboardRoleMap ? obj.dashboardRoleMap.isWrite : false
          obj.isActive = obj.dashboardRoleMap ? obj.dashboardRoleMap.isActive : false
          obj.selectedModule = obj.dashboardRoleMap ? _.map(obj.dashboardRoleMap.subDashboardRoleMaps, 'subDashboardID') : []
          obj.isActiveInactive = obj.isActive ? 'Active' : 'Deactive'
          this.data.push(obj)
        })
        this.total = this.data.length

        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching User : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    saveRow: async function (rowIndex) {
      try {
        let formData = {
          dashboardID: rowIndex.id,
          subDashboard: rowIndex.selectedModule,
          isActive: rowIndex.isActive,
          isWrite: rowIndex.isWrite,
          isDefault: rowIndex.isDefault
        }

        console.log('command promt---', formData)
        await http.post(`${constants.API_URL}/api/dashboard-role-map`, { dashboardRoleMap: [formData], roleID: this.roleId })
        // this.loader = false
        // this.$router.push({ name: 'Franchisee' })
        return this.$dialog.info({
          title: 'Success',
          text: 'Module Saved successfully!'
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
